import { Box } from "@mui/material";
import React from "react";

export function PageContainer({ children }: { children: React.ReactNode }) {
  return (
    <Box
      marginBottom="2rem"
      display="flex"
      flexDirection={"row"}
      flexWrap={"wrap"}
      justifyContent={"center"}
      width={"100%"}
    >
      {children}
    </Box>
  );
}
